import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async pesquisarVendedores(api, parametros) { 
    parametros.operacao = 'pesquisarVendedores';
    
    let retorno = {};
    
    await api.santriGET('/rest/vendedor', parametros, 15, false)
      .then(response => {
        retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
      })
      .catch(error => {
        retorno = Biblioteca.retornoRequisicao('S', error, undefined);
      })
  
      return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/RVendedor.js